import { useQuery } from "react-query";
import { planApi } from "@/react/api";
import { usePriceTestingEnabled } from "@/react/hooks/experiments/usePriceTestingEnabled";

export interface UseFetchPlanProps {
  billingCurrency?: string;
  locale?: string;
  planId?: string;
  planTier?: string;
  planType?: string;
}

export const useFetchPlan = ({
  planTier = "",
  planId = "",
  billingCurrency = "",
  locale = "",
  planType = "",
}: UseFetchPlanProps) => {
  const shouldFetchPlan = Boolean(planTier || planId);
  const isPriceTestingEnabled = usePriceTestingEnabled();

  const {
    data: plan,
    isLoading: isPlanLoading,
    error: errorFetchingPlan,
  } = useQuery(
    [
      "plan",
      "fetch",
      planTier,
      planId,
      billingCurrency,
      locale,
      planType,
      isPriceTestingEnabled,
    ],
    () =>
      planApi.fetch({
        tier: planTier,
        id: planId,
        billing_currency: billingCurrency,
        locale: locale,
        plan_type: planType,
        isPriceTestingEnabled,
      }),
    {
      enabled: shouldFetchPlan,
    },
  );

  return {
    plan,
    isPlanLoading,
    errorFetchingPlan,
  };
};
